import cn from 'classnames';

import styles from './Rating.module.scss';

const baseClass = 'gdb-rating';

interface Props {
  rating: number;
  title?: string;
  className?: string;
}

export const Rating = ({ rating, className }: Props) => {
  const totalStars = 5;
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 !== 0;

  const starTypes = {
    full: (
      <svg className={styles[`${baseClass}-star`]} viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
      </svg>
    ),
    half: (
      <div className={styles[`${baseClass}-star-wrapper`]}>
        <svg
          className={cn(styles[`${baseClass}-star`], styles[`${baseClass}-star-empty`])}
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
        </svg>
        <svg
          className={cn(styles[`${baseClass}-star`], styles[`${baseClass}-star-half`])}
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path d="M12 2L9.19 8.63L2 9.24l5.46 4.73L5.82 21L12 17.27V2z" />
        </svg>
      </div>
    ),
    empty: (
      <svg
        className={cn(styles[`${baseClass}-star`], styles[`${baseClass}-star-empty`])}
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
      </svg>
    ),
  };

  const getStarType = (index: number) => {
    if (index < fullStars) return 'full';
    if (index === fullStars && hasHalfStar) return 'half';
    return 'empty';
  };

  return (
    <div className={cn(styles[`${baseClass}-stars`], className)}>
      {[...Array(totalStars)].map((_, index) => (
        <span key={index}>{starTypes[getStarType(index)]}</span>
      ))}
    </div>
  );
};
